/**
 * This utility centralizes the creation of Web Workers to ensure compatibility
 * with bundlers (using new URL(..., import.meta.url)) while remaining testable in Jest.
 */

export const createVirtualBackgroundWorker = () => {
  return new Worker(new URL('./virtual-background.worker', import.meta.url), {
    name: 'virtual-background-worker',
  });
};

export const createTimerWorker = () => {
  return new Worker(new URL('./timer.worker', import.meta.url), {
    name: 'timer-worker',
  });
};
